// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stage-tag .stage-HA {
  background-color: #207656;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}
.stage-tag .stage-HA {
  background-color: #207656;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}
.stage-tag .stage-H2L {
  background-color: #DCB14E;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}
.stage-tag .stage-LO {
  background-color: #52422D;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}
.stage-tag .stage-SP {
  background-color: #D86D6F;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}
.stage-tag .stage-IND {
  background-color: #53A9A8;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}
.stage-tag .stage-P1 {
  background-color: #344e41;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}

.stage-tag .stage-Portfolio {
  background-color: #64d777;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}

.stage-tag .stage-Terminated {
  background-color: #000000;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
  text-transform: capitalize;
}


.stage-tag .stage-Dotted {
  background-color: #e5e5f7;
  opacity: 0.8;
  background: repeating-linear-gradient( -45deg, #444cf7, #444cf7 1px, #A9CCE3 1px, #A9CCE3 5px );
  min-width: 5rem;
}


`, "",{"version":3,"sources":["webpack://./src/app/common/StageTag/StageTag.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,+FAA+F;EAC/F,eAAe;AACjB","sourcesContent":[".stage-tag .stage-HA {\n  background-color: #207656;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n.stage-tag .stage-HA {\n  background-color: #207656;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n.stage-tag .stage-H2L {\n  background-color: #DCB14E;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n.stage-tag .stage-LO {\n  background-color: #52422D;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n.stage-tag .stage-SP {\n  background-color: #D86D6F;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n.stage-tag .stage-IND {\n  background-color: #53A9A8;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n.stage-tag .stage-P1 {\n  background-color: #344e41;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n\n.stage-tag .stage-Portfolio {\n  background-color: #64d777;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n\n.stage-tag .stage-Terminated {\n  background-color: #000000;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n  text-transform: capitalize;\n}\n\n\n.stage-tag .stage-Dotted {\n  background-color: #e5e5f7;\n  opacity: 0.8;\n  background: repeating-linear-gradient( -45deg, #444cf7, #444cf7 1px, #A9CCE3 1px, #A9CCE3 5px );\n  min-width: 5rem;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
